import { SuiteManifest } from '../manifest';
import { communicationRoutes } from './routes';

export const communicationManifest: SuiteManifest = {
  id: 'communication',
  code: 'S6_COMM',
  name: 'Communication',
  basePath: '/communication',
  icon: 'message-square',
  description: 'Unified email, SMS, WhatsApp Business API adapters, in-app push alerts, student-teacher chat, and academic Q&A forums.',
  requiredPermission: 'comm.read',
  nav: [
    { label: 'In-App Chat Hub', path: '/communication/chat', icon: 'message-square', group: 'Messaging', status: 'live' },
    { label: 'Push Notifications & Alerts', path: '/communication/notifications', icon: 'bell', group: 'Messaging', status: 'live' },
    { label: 'Broadcast Campaigns', path: '/communication/broadcasts', icon: 'send', group: 'Messaging', status: 'live', permission: 'broadcasts.send', allowedRoles: ['owner', 'admin', 'branch_head', 'counselor', 'accountant'] },
    { label: 'Academic Q&A Forum', path: '/communication/forum', icon: 'message-square', group: 'Community', status: 'live' },
    { label: 'Merge Templates', path: '/communication/templates', icon: 'file-text', group: 'Tools', status: 'live', allowedRoles: ['owner', 'admin', 'branch_head'] },
    { label: 'PTM Scheduler', path: '/communication/ptm', icon: 'calendar', group: 'Tools', status: 'live', permission: 'ptm.manage', allowedRoles: ['owner', 'admin', 'branch_head', 'teacher', 'counselor', 'parent', 'student'] },
  ],
  routes: communicationRoutes,
};

export { communicationRoutes } from './routes';
export default communicationManifest;
